export default __webpack_public_path__ + "static/media/BIDS_Banner-Image-1536x418.d8dfba85.jpg";